(() => {
  if (window.lomaVistaMastodonTermsLoaded) return;
  window.lomaVistaMastodonTermsLoaded = true;
  const popupId = 'MastodonRaffleTerms';
  const popupHash = `#${popupId}`;
  let state;

  function finish(record) {
    if (state !== record) return;
    document.documentElement.classList.remove('mastodon-terms-open');
    if (window.location.hash === popupHash) {
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
    }
    if (record.opener?.isConnected) record.opener.focus({ preventScroll: true });
    record.opener = undefined;
  }

  function dispose() {
    if (!state) return;
    const record = state;
    record.dialog.close();
    finish(record);
    record.dialog.removeEventListener('close', record.onClose);
    state = undefined;
  }

  function open(opener) {
    if (!state || state.dialog.open) return;
    state.opener = opener;
    state.dialog.showModal();
    document.documentElement.classList.add('mastodon-terms-open');
  }

  function initialize() {
    const dialog = document.getElementById(popupId);
    if (state?.dialog === dialog) return;
    dispose();
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const record = { dialog };
    record.onClose = () => finish(record);
    dialog.addEventListener('close', record.onClose);
    state = record;
    document.querySelectorAll('[data-mastodon-terms-open]').forEach(link => {
      link.setAttribute('href', popupHash);
    });
    if (window.location.hash === popupHash) open();
  }

  document.addEventListener('click', event => {
    if (!state) return;
    const link = event.target.closest(`a[href="${popupHash}"], [data-mastodon-terms-open]`);
    if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
      event.preventDefault();
      open(link);
    } else if (event.target.closest('[data-mastodon-terms-close]')) {
      state.dialog.close();
      finish(state);
    } else if (event.target === state.dialog) {
      const bounds = state.dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
        state.dialog.close();
        finish(state);
      }
    }
  });
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    if (state && event.target.contains(state.dialog)) dispose();
  });
  window.addEventListener('hashchange', () => {
    if (window.location.hash === popupHash) open();
  });
  window.addEventListener('pagehide', () => {
    if (state?.dialog.open) {
      state.dialog.close();
      finish(state);
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
